import React from "react";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import GalleryButton from "./GalleryActionButton";
import { useHeroGalleryVideo } from "./HeroGalleryVideoContext";
import styles from "./HeroGalleryVideoButton.scss";

const HeroGalleryVideoButton: React.FC = () => {
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };
  const { isVideoAvailable, isVideoVisible, openVideo, triggerRef } =
    useHeroGalleryVideo();

  if (!isVideoAvailable) {
    return null;
  }

  return (
    <GalleryButton
      ref={triggerRef}
      iconClass={isVideoVisible ? "product-play-filled" : "product-play"}
      ariaLabel={getTranslation("pdp_media_video_player_label")}
      buttonText={getTranslation("pdp_misc_video")}
      handleClick={openVideo}
      dataTestId="videoButtonHero"
      className={isVideoVisible ? styles.active : undefined}
    />
  );
};

export default HeroGalleryVideoButton;
